 

import DateFnsAdapter from '@date-io/date-fns'
import bg from 'date-fns/locale/bg'
import cy from 'date-fns/locale/cy'
import gl from 'date-fns/locale/gl'
import de from 'date-fns/locale/de'
import enGb from 'date-fns/locale/en-GB'
import es from 'date-fns/locale/es'
import et from 'date-fns/locale/et'
import fr from 'date-fns/locale/fr'
import gu from 'date-fns/locale/gu'
import hi from 'date-fns/locale/hi'
import hu from 'date-fns/locale/hu'
import lt from 'date-fns/locale/lt'
import lv from 'date-fns/locale/lv'
import nl from 'date-fns/locale/nl'
import pl from 'date-fns/locale/pl'
import ro from 'date-fns/locale/ro'
import sk from 'date-fns/locale/sk'
import tr from 'date-fns/locale/tr'
import uk from 'date-fns/locale/uk'
import zhCn from 'date-fns/locale/zh-CN'
import zhTw from 'date-fns/locale/zh-TW'

const date = {
  adapter: DateFnsAdapter,
  locale: {
    bg: bg,
    cy: cy,
    de: de,
    de_CH: de,
    en: enGb,
    es: es,
    et: et,
    fr: fr,
    ga: gl,
    gu: gu,
    hi: hi,
    hu: hu,
    lt: lt,
    lv: lv,
    nl: nl,
    pl: pl,
    ro: ro,
    sk: sk,
    tr: tr,
    uk: uk,
    zh_CN: zhCn,
    zh_TW: zhTw,
  },
}

export default date
